var MyException = /** @class */ (function () {
    function MyException(status, body) {
        this.status = status;
        this.body = body;
    }
    return MyException;
}());
export { MyException };
//# sourceMappingURL=multiselect.model.js.map


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/angular4-multiselect-dropdown/dist/multiselect.model.js
// module id = ../../../../angular4-multiselect-dropdown/dist/multiselect.model.js
// module chunks = common